import React, { useState, useContext, useEffect } from "react";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import Profile from "./Profile";
// import Notify from "./Notify";
import Upgrade from "./Upgrade";
import UpdateCC from "./UpdateCC";
import { useHotKeys } from "App/common/hooks/hotKeys";
import { LayoutContext } from "App/common/hoc/Layout";
import Tooltip from "App/common/ui/Tooltip";
import { TOOLTIPS } from "consts";
import { ReactComponent as HamburgerIcon } from "assets/images/app_svg/hamburger.svg";
import { ReactComponent as StatsArrowIcon } from "assets/images/app_svg/statistics_arrow.svg";
import RestoreMachines from "./RestoreMachines";
import { config } from "config";
import { STATIC_URLS } from "consts";
import {
  fetchClientVersionInfoStart,
  fetchDeploymentTokenStart
} from "store/actions";

function Toolbar(props) {
  const [showDropdown, setShowDropdown] = useState({
    profile: false,
    notify: false,
    restoreMachines: false
  });
  const { lState, lMethods } = useContext(LayoutContext);

  useHotKeys(
    "esc",
    e => {
      e.preventDefault();
      setShowDropdown({ profile: false, notify: false });
    },
    [showDropdown]
  );

  function toggleHandler(type) {
    setShowDropdown(prevState => ({
      ...prevState,
      [type]: !prevState[type]
    }));
  }

  function clickAwayHandler(type) {
    setShowDropdown(prevState => ({ ...prevState, [type]: false }));
  }

  useEffect(() => {
    if (!props.route.pathname.includes("/restore/"))
      clickAwayHandler("restoreMachines");
  }, [props.route.pathname]);

  return (
    <div className="main_navbar">
      <div className="inner_navbar">
        <div className="navbar_left">
          <div
            className="navbar_logo"
            onClick={() =>
              window.location.assign(
                STATIC_URLS.home[
                  props?.origin === "idrive" ? "idrive" : config.APP_INSTANCE
                ]
              )
            }
          >
            <img
              src={
                process.env.REACT_APP_STATIC_URL +
                STATIC_URLS.logo[config.APP_INSTANCE].url
              }
              alt={STATIC_URLS.logo[config.APP_INSTANCE].alt}
              style={{ width: "200px" }}
              className={
                config.APP_INSTANCE === "ibackup" ? "ibackup_logo" : undefined
              }
            />
          </div>
          <Tooltip {...TOOLTIPS.dashboard.menu}>
            <div
              className="hamburger flex_center"
              onClick={lMethods.toggleSidebar}
            >
              <span className="icon">
                <HamburgerIcon />
              </span>
            </div>
          </Tooltip>
          {props.route.pathname.includes("/restore/") && (
            <ClickAwayListener
              onClickAway={() => clickAwayHandler("restoreMachines")}
            >
              <div
                className={[
                  "machine_wrap",
                  showDropdown.restoreMachines ? "active" : ""
                ].join(" ")}
                onClick={() => toggleHandler("restoreMachines")}
              >
                <RestoreMachines />
              </div>
            </ClickAwayListener>
          )}
          {props.plan &&
          props.plan.planType === "Paid" &&
          props.origin === null &&
          props.ecommerceFlag !== "S" &&
          props.ecommerceFlag !== "O" ? (
            <UpdateCC planId={props.plan.id} userLimit={props.plan.userLimit} />
          ) : (
            <Upgrade />
          )}
        </div>
        <div className="navbar_right">
          <ul className="navbar_right_ul">
            {/* <ClickAwayListener onClickAway={() => clickAwayHandler("notify")}>
              <li
                className={[
                  "navbar_notify",
                  showDropdown.notify ? "active" : ""
                ].join(" ")}
                onClick={() => toggleHandler("notify")}
              >
                <Notify showDropdown={showDropdown.notify} />
              </li>
            </ClickAwayListener> */}
            {props.route.pathname.includes("dashboard") && (
              <div className="add-comp_blk">
                <div
                  className="add_computer_btn btn-add-computer"
                  onClick={() => {
                    lMethods.openSlidingPopup("addPC", "addComputer");
                    props.fetchClientVersionInfoStart();
                    props.fetchDeploymentTokenStart();
                  }}
                >
                  Add Computer
                </div>
              </div>
            )}
            <ClickAwayListener onClickAway={() => clickAwayHandler("profile")}>
              <li
                className={[
                  "navbar_profile",
                  showDropdown.profile ? "active" : ""
                ].join(" ")}
                onClick={() => toggleHandler("profile")}
              >
                <Profile showDropdown={showDropdown.profile} />
              </li>
            </ClickAwayListener>
            {props.route.pathname.includes("dashboard") &&
              props.noOfClients > 0 && (
                <li
                  className={
                    "statistics_arrow svg_icon" +
                    (lState.backupStats.show ? " active" : "")
                  }
                  onClick={lMethods.toggleBackupStats}
                >
                  <Tooltip
                    {...TOOLTIPS.dashboard[
                      !lState.backupStats.show ? "showStats" : "hideStats"
                    ]}
                  >
                    <span className="icon">
                      <StatsArrowIcon />
                    </span>
                  </Tooltip>
                </li>
              )}
          </ul>
        </div>
      </div>
    </div>
  );
}

function mapStateToProps(state) {
  return {
    plan: state.account.plan
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    { fetchClientVersionInfoStart, fetchDeploymentTokenStart },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(Toolbar);
